var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.435,
    height: 22.368,
    viewBox: "0 0 25.435 22.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10824",
    "data-name": "Trazado 10824",
    d: "M30.6,177H56.032v22.368H30.6Zm0,0",
    transform: "translate(-30.598 -177)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "The_Last_of_Us",
    "data-name": "The Last of Us",
    transform: "translate(-30.598 -177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11488",
    "data-name": "Grupo 11488",
    transform: "translate(30.598 177)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10823",
    "data-name": "Trazado 10823",
    d: "M43.7,177.117l.046.046h.232l.093.046h.046l.371.185.046.093.046.046.093.046.046.093.139.139,5.665,9.825,5.607,9.767.046.093.093.185.046.093v.232l.046.093-.046.139v.185l-.093.185v.093l-.093.093-.046.093-.139.139-.046.093-.046.046-.278.139-.046.046-.093.046h-.093l-.093.046h-.185l-.093.046H43.657l-11.271-.046h-.324l-.093-.046h-.093l-.093-.046-.046-.046-.278-.139-.093-.093-.046-.046-.046-.093-.046-.046-.046-.093-.093-.093v-.093l-.046-.046v-.093L31,198.423v-.185l-.046-.139.046-.093v-.232l.093-.185V197.5l.093-.093,5.607-9.767,5.665-9.778.046-.093.093-.093.046-.093.185-.185.093-.046.046-.046.139-.046.093-.046h.093l.093-.046h.232l.093-.046",
    transform: "translate(-30.937 -177.113)",
    fill: "#a80b38",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10825",
    "data-name": "Trazado 10825",
    d: "M63.55,197.57l.046.046.185.093h.046l.046.093.046.046.093.093,11.271,19.545.093.093v.093l.046.046v.185l-.046.139-.046.093-.046.093-.185.185-.093.046-.093.046-.139.046H52l-.046-.046h-.093l-.046-.046h-.046l-.046-.046-.093-.046-.093-.093-.046-.139-.046-.093L51.4,217.9v-.093l.046-.139.046-.093v-.093h.046l11.271-19.545v-.046l.232-.232h.046l.046-.046h.139l.046-.046Zm9.511,19.313h-19.3l9.65-16.718,9.65,16.718",
    transform: "translate(-20.094 -19.871)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10826",
    "data-name": "Trazado 10826",
    d: "M358.512,369.506l.046-.093v-.139l.046-.093v-.139l.046-.046v-.046l.139-.232.093-.185.185-.139.139-.139.232-.093.185-.093.232-.046h.185l.232.046.185.046.232.046.139.139.185.093.139.139.139.185.093.139v.093l.046.046.046.093v.093l.046.093v.232l-.556,6.106-.046.185-.046.139-.139.139-.093.139-.139.093-.278.093H359.9l-.185-.046-.139-.046-.278-.185-.093-.139-.093-.185-.046-.185Zm1.529,7.82.324.046.278.093.232.139.232.185.185.232.139.232.093.278.046.324-.046.278-.093.278-.139.278-.185.232-.232.185-.232.139-.278.093h-.6l-.278-.093-.278-.139-.232-.185-.185-.232-.139-.278-.093-.278v-.6l.093-.278.139-.232.185-.232.232-.185.278-.139.278-.093.278-.046",
    transform: "translate(-316.77 -184.531)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.fb3d4b8ea804258b73b33ac515134f73.svg";
export { ForwardRef as ReactComponent };